/**
 * Abstract interface for a Tour Engine.
 * Any underlying tour engine (Driver.js, Shepherd.js, Intro.js, or custom)
 * must implement these methods.
 */
export class TourEngineInterface {
  /**
   * Initialize engine with global options
   * @param {Object} options
   */
  // eslint-disable-next-line no-unused-vars
  init(options = {}) {
    throw new Error('TourEngineInterface.init() must be implemented.');
  }

  /**
   * Start the tour with formatted steps
   * @param {Array<Object>} steps - Standardized steps. Each step can include:
   *   - target: string selector or HTMLElement
   *   - title: string
   *   - description: string
   *   - position: 'top' | 'bottom' | 'left' | 'right'
   *   - align: 'start' | 'center' | 'end'
   *   - scrollIntoView: boolean | ScrollIntoViewOptions (smooth scroll to element)
   *   - openMenu: Function | string selector (triggers opening a menu/drawer for hidden elements)
   *   - closeMenu: Function | string selector (triggers closing the menu when navigating away)
   *   - beforeEnter: async (step, context) => void
   *   - afterLeave: async (step, context) => void
   *   - allowMissing: boolean (skip if not available)
   * @param {Object} [options]
   */
  // eslint-disable-next-line no-unused-vars
  drive(steps, options = {}) {
    throw new Error('TourEngineInterface.drive() must be implemented.');
  }

  /**
   * Navigate to next step
   */
  next() {
    throw new Error('TourEngineInterface.next() must be implemented.');
  }

  /**
   * Navigate to previous step
   */
  previous() {
    throw new Error('TourEngineInterface.previous() must be implemented.');
  }

  /**
   * Destroy and close active tour
   */
  destroy() {
    throw new Error('TourEngineInterface.destroy() must be implemented.');
  }

  /**
   * Check if a tour is currently running
   * @returns {boolean}
   */
  isActive() {
    throw new Error('TourEngineInterface.isActive() must be implemented.');
  }
}

export default TourEngineInterface;
